import MainLogo from "../../assets/MainLogo.webp";

const LoadingCircle = () => {
  return (
    <div className="loadingOverlay">
      <img src={MainLogo} alt="Logo" style={{ height: 50 }} />
      <div className="loadingOverlay-tree">
        <div className={`loadingOverlay-dots dot`} />
        <div className={`loadingOverlay-dots dot`} />
        <div className={`loadingOverlay-dots dot`} />
      </div>
    </div>
  );
};

export default LoadingCircle;
